const dataReceipts = "/data-receipts"
const sensorInstallations = "/sensor-installations"

export const routes = {
    home: "/",
    login: "/login",
    projectInit: "/projects/initialize",
    projectEditor: "/project-editor",
    missionUpload: "/mission-upload",
    missionSelect: "/mission-select",
    missionEditor: "/mission-editor",
    missionReview: "/mission-review",
    flightplanUpload: "/flightplan-upload",
    flightplanEditor: "/flightplan-editor",
    lookupEditor: "/lookup-table",
    dataReceipts,
    createDataReceipt: `${dataReceipts}/create`,
    editDataReceipt: (dataReceiptId = ":dataReceiptId") => `${dataReceipts}-editor/${dataReceiptId}`,
    sensorInstallations,
    sensorInstallationsForSensor: (sensorId?: string | number) =>
        `${sensorInstallations}/sensor/${sensorId ?? ":sensorId"}`,
    confirmation: (
        route?: ConfirmationRoutes,
        values?: {
            entityName?: string
            projectNumber?: string
        },
    ) => {
        const params = values == null ? "" : `?${new URLSearchParams(values).toString()}`
        return `/confirmation/${route ?? ":confirmationRoute"}${params}`
    },
}

export enum ConfirmationRoutes {
    MISSION_SUBMITTED = "mission-submitted",
    MISSION_EDITED = "mission-edited",
    MISSION_REVIEWED = "mission-reviewed",
    FLIGHTPLAN_SUBMITTED = "flightplan-submitted",
    FLIGHTPLAN_EDITED = "flightplan-edited",
    PROJECT_EDITED = "project-edited",
    DATA_RECEIPT_SUBMITTED = "data-receipt-submitted",
    DATA_RECEIPT_UPDATED = "data-receipt-updated",
}
